import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import {
  concatMap,
  filter,
  map,
  take,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import {
  AnonymousConsentsConfig,
  AuthActions, AuthService, RoutingService,
  UserActions, UserConsentService, UserIdService
} from "@spartacus/core";

@Injectable()
export class GonvarriAnonymousConsentsEffects {

  giveRequiredConsentsToUser$: Observable<
    UserActions.GiveUserConsent | Observable<never>
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<AuthActions.Login>(AuthActions.LOGIN),
      filter((action) =>
        Boolean(
          this.anonymousConsentsConfig.anonymousConsents &&
          this.anonymousConsentsConfig.anonymousConsents.requiredConsents &&
          action
        )
      ),
      concatMap(() =>
        this.userConsentService.getConsentsResultSuccess().pipe(
          take(1),
          withLatestFrom(
            this.userIdService.getUserId(),
            this.userConsentService.getConsents(),
            this.authService.isUserLoggedIn()
          ),
          filter(([, , , loggedIn]) => loggedIn),
          tap(([loaded, _userId, _templates, _loggedIn]) => {
            if (!loaded) {
              this.userConsentService.loadConsents();
            }
          }),
          concatMap(() => {
            const actions: UserActions.GiveUserConsent[] = [];
            this.routingService.goByUrl('/');
            return actions;
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private anonymousConsentsConfig: AnonymousConsentsConfig,
    private userConsentService: UserConsentService,
    private userIdService: UserIdService,
    private routingService: RoutingService
  ) {}

}
